import HintMessage from '@/core/components/HintMessage/HintMessage';

export default HintMessage;
